import { useRef } from "react";

import { Button } from "@/components/button";
import { useFeedbackTool } from "@/features/request/feedback-tool/feedbackTool/hooks/useFeedbackTool.tsx";

export const Points = ({ currentTime }: { currentTime: number }) => {
  const {
    feedback: feedBack,
    formFeedBack,
    selected,
    setFormFeedBack,
    setSelected,
    videoRef,
  } = useFeedbackTool();
  const video = videoRef.current;
  const buttonRefs = useRef<HTMLButtonElement[]>([]);

  if (!video) return;

  return feedBack?.map((item) => {
    const isVisible =
      item?.timestamp && Math.abs(item?.timestamp - currentTime) < 0.3;

    return (
      <Button
        className={`
          absolute bg-white w-5 h-7 flex justify-center items-center rounded-full text-black cursor-pointer 
          ${item.id === selected?.id ? "bg-button-primary-bg text-white" : "bg-white text-black"} z-[2] 
          ${isVisible ? "opacity-100" : "hidden"}
        `}
        key={`point-${item.id}`}
        onPress={() => {
          if (formFeedBack) setFormFeedBack(null);

          if (item === selected) {
            setSelected(null);
          } else {
            setSelected(item);
          }

          const timestamp = item.timestamp;

          if (typeof timestamp === "number" && !Number.isNaN(timestamp)) {
            video.currentTime = timestamp;
          }
        }}
        ref={(el) => {
          if (el) {
            buttonRefs.current[item?.id] = el;
          }
        }}
        style={{
          left: item.x,
          top: item.y,
          transform: "translate(-50%, -50%)",
        }}
      >
        {item.id}
      </Button>
    );
  });
};
